import { createSlice } from '@reduxjs/toolkit';
import { verifyOtp } from '../actions/verifyOtpAction';

const initialState = {
  isLoading: false,
  error: null,
  success: false,
  data: null,
};

const verifyOtpSlice = createSlice({
  name: 'verifyOtp',
  initialState,
  reducers: {
    resetVerifyOtpState: (state) => {
      state.isLoading = false;
      state.error = null;
      state.success = false;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyOtp.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.success = false;
        state.error = action.payload || 'Verification failed';
      });
  },
});

export const { resetVerifyOtpState } = verifyOtpSlice.actions;
export default verifyOtpSlice.reducer;
